var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDaily(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24.000000pt",
    height: "24.000000pt",
    viewBox: "0 0 24.000000 24.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,24.000000) scale(0.100000,-0.100000)",
    fill: "",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 206 c-87 -48 -50 -186 49 -186 51 0 100 49 100 99 0 75 -83 124 -149 87z m104 -31 c33 -32 33 -78 0 -110 -49 -50 -135 -15 -135 55 0 41 39 80 80 80 19 0 40 -9 55 -25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110 147 c0 -21 8 -41 20 -52 25 -23 39 -12 17 13 -10 10 -17 31 -17 45 0 15 -4 27 -10 27 -5 0 -10 -15 -10 -33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaily);
export default __webpack_public_path__ + "static/media/daily.432ad46ebc29a871f25ecdf58b51d5ce.svg";
export { ForwardRef as ReactComponent };